import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-btn-arrow-down",
  "use": "icon-btn-arrow-down-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-btn-arrow-down\"><style>#icon-btn-arrow-down .st0{fill:#333}</style><path class=\"st0\" d=\"M17.2 10.3c0-4-3.3-7.3-7.3-7.3s-7.3 3.3-7.3 7.3 3.3 7.3 7.3 7.3 7.3-3.2 7.3-7.3z\" /><path class=\"st0\" d=\"M17.2 10.3c0-4-3.3-7.3-7.3-7.3s-7.3 3.3-7.3 7.3 3.3 7.3 7.3 7.3 7.3-3.2 7.3-7.3z\" /><path d=\"M10 1c-5 0-9 4.1-9 9.1s4.1 9.1 9.1 9.1 9-4.1 9-9.1S15 1 10 1zm.1 13.1L5.3 9.4 6.7 8l3.4 3.3 3.2-3.2 1.4 1.4-4.6 4.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol